import { render, staticRenderFns } from "./DonutChart12.vue?vue&type=template&id=83dc038e&scoped=true&"
import script from "./DonutChart12.vue?vue&type=script&lang=js&"
export * from "./DonutChart12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dc038e",
  null
  
)

export default component.exports